import React, { useState, useEffect } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { Input, Label } from './Input';
import { ImageUpload } from './ImageUpload';
import { useToast } from './Toast';
// MIGRATION FIREBASE: Utilise Firebase direct au lieu de l'API Python
import { categoriesService } from '../services/firebaseService';

export const CategoryModal = ({ isOpen, onClose, category, onSuccess }) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    icon: '',
    order: 0,
    is_active: true,
  });

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || '',
        image: category.image || '',
        icon: category.icon || '',
        order: category.order || 0,
        is_active: category.is_active ?? true,
      });
    } else {
      setFormData({
        name: '',
        image: '',
        icon: '',
        order: 0,
        is_active: true,
      });
    }
  }, [category]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log("formData avant submit:", formData);
      const payload = {
        ...formData,
        order: parseInt(formData.order),
      };

      // FIREBASE DIRECT
      if (category) {
        await categoriesService.update(category.id, payload);
      } else {
        await categoriesService.create(payload);
      }

      onSuccess();
      onClose();
      toast.success('Succès', category ? 'Catégorie mise à jour' : 'Catégorie créée');
    } catch (error) {
      toast.error('Erreur', error.response?.data?.detail || 'Erreur inconnue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={category ? 'Modifier la catégorie' : 'Nouvelle catégorie'}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="name">Nom de la catégorie *</Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </div>

        <ImageUpload
          currentImage={formData.image}
          onImageChange={(url) => setFormData({ ...formData, image: url })}
          label="Image de la catégorie"
        />

        <div>
          <Label htmlFor="icon">Icône (Lucide)</Label>
          <Input
            id="icon"
            value={formData.icon}
            onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
            placeholder="package, coffee, etc."
          />
        </div>

        <div>
          <Label htmlFor="order">Ordre d'affichage</Label>
          <Input
            id="order"
            type="number"
            value={formData.order}
            onChange={(e) => setFormData({ ...formData, order: e.target.value })}
          />
        </div>

        <div>
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4 text-primary rounded"
            />
            <span className="text-sm font-semibold text-gray-700">Active</span>
          </label>
        </div>

        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <Button type="button" variant="secondary" onClick={onClose}>
            Annuler
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Enregistrement...' : category ? 'Mettre à jour' : 'Créer'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
